import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

export function ReferralStatusLoadingCard() {
  return <BaseReferralStatusCard isLoading title="Loading referral information..." />;
}
